import { Inject, Injectable, QueryList } from '@angular/core';
import { AuthService } from '../auth/auth.service';
import { AppManagerServiceApiService } from '../api/app-manager-api.service';
import { AuthUserInfo } from '../auth/auth-user-info.model';
import { CreateInsightsSessionDto } from './dto/create-insights-session-dto';

@Injectable({ providedIn: 'root' })
export class AppManagerService {
  constructor(private _authService: AuthService, private _appManagerApiService: AppManagerServiceApiService) {}

  public getInsightsUrl = (): Promise<string> => {
    return this._authService.getUserInfo().then((data: AuthUserInfo) => {
      var url = 'v1/insights/session/url';
      var sessionRequest = new CreateInsightsSessionDto();
      sessionRequest.sourceUsername = data.wli_username;
      sessionRequest.sourceUserId = data.wli_usernum;
      sessionRequest.tenantId = this._authService.getTenant();
      sessionRequest.productId = 'mc_trade';

      return this._appManagerApiService.postRawTextReturn(url, sessionRequest).then((data: string) => {
        return data;
      });
    });
  };
}
